import React, { useMemo } from 'react'
import styled from 'styled-components'
import Flex from 'components/reusable/flex'
import Image from 'components/reusable/image'
import Text from 'components/reusable/text'
import ReferralShareSection from 'components/complex/referral_share_section'
import AuthHelper from 'helpers/auth_helper'
import RouterHelper from 'helpers/router_helper'
import useReferrerRole from 'hooks/use_referrer_role'
import { colors } from 'helpers/colors'
import { cardBoxShadow } from 'helpers/style'
import ApplicationHelper from 'helpers/application_helper'
import ModalCloseButtonV2 from '../modal_close_button_v2'

const ModalWrapper = styled.div`
  display: flex;
  border-radius: 24px;
  overflow: hidden;
  ${cardBoxShadow}
  width: 80vw;
  max-width: 1150px;
  max-height: 90vh;
  
  @media (max-width: 768px) {
    width: 100vw;
    flex-direction: column;
    max-height: 95vh;
    border-radius: 24px 24px 0 0;
  }
`

const ImageSection = styled.div`
  position: relative;
  width: 50%;
  min-height: 500px;
  flex-shrink: 0;

  @media (min-width: 769px) and (max-width: 1200px) {
    width: 330px;
    
    img {
      object-position: left;
    }
  }
  
  @media (max-width: 768px) {
    width: 100%;
    min-height: 180px;
    height: 180px;
  }
`

const DesktopImage = styled(Image)`
  @media (max-width: 768px) {
    display: none;
  }
`

const MobileImage = styled(Image)`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    object-position: center;
  }
`

const ContentSection = styled(Flex)`
  flex: 1;
  padding: 32px;
  background: ${colors.light};
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`

const DesktopOnly = styled.div`
width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`

const MobileOnly = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${colors.gray[100]};
  margin: 8px 0;
`


function WaitlistWelcomeModal({ onClose }) {
  const role = useReferrerRole()
  const referralCode = useMemo(() => AuthHelper.currentUser()?.referral_code, [])
  const url = useMemo(() => RouterHelper.getReferralLink(referralCode), [referralCode])
  const isMobile = ApplicationHelper.isMobile

  return (
    <ModalWrapper>
      <ModalCloseButtonV2 onClose={onClose} />

      <ImageSection>
        <DesktopImage src="/images/backgrounds/referrals-banner-desktop.png" width="100%" height="100%" />
        <MobileImage src="/images/backgrounds/referrals-banner-mobile.png" width="100%" height="100%" />
      </ImageSection>

      <ContentSection dir="column" jc="flex-start" ai="flex-start" gap={20}>
        <Flex dir="column" ai="flex-start" gap={8} width="100%">
          <Text size={isMobile ? 24 : 32} weight={500}>Welcome to SWIPECAST!</Text>
          
          <DesktopOnly>
            <Text size={16} color={colors.gray[500]} lineHeight="140%">
              You're on the Waitlist. We're reviewing your application.
              <br />
              In the meantime, start earning referral credits.
            </Text>
          </DesktopOnly>
          
          <MobileOnly>
            <Text size={14} color={colors.gray[500]} lineHeight="140%">
              You're on the waitlist.
              <br />
              While you wait, invite your friends.
            </Text>
          </MobileOnly>
        </Flex>

        <DesktopOnly>
          <Divider />
        </DesktopOnly>

        <DesktopOnly>
          <Text size={24} weight={500}>Grant exclusive access to your friends:</Text>
        </DesktopOnly>

        <ReferralShareSection url={url} referrerRole={role} />
      </ContentSection>
    </ModalWrapper>
  )
}

export default WaitlistWelcomeModal
